import React from 'react';
import ReactDOM from 'react-dom';
import Select from 'react-select';
import { filterSortingOptionsList } from '../../core-react/types/ProductListFilterInterface';
import { getSearchParams } from './utils';
(function () {
	const productFilters: Record<string, string[]> = {};
	const filterTypes: string[] = [];

	new URL(window.location.href).searchParams.forEach((value, key) => {
		productFilters[key.toLocaleLowerCase()] = value.split('|');
	});

	const productOptionE = document.querySelector(
		'[data-product-listing-option] select'
	) as HTMLSelectElement;

	const initialSelect = () => {
		document
			.querySelectorAll('[data-select-for=productListing]')
			.forEach((item) => {
				const select = item.querySelector('select');
				const options: filterSortingOptionsList[] = Array.from(
					select.querySelectorAll('option')
				).map((item: HTMLOptionElement) => ({
					value: item.value,
					label: item.text,
				}));
				const selectvalue = options.find(
					(item) =>
						item.value.toLocaleLowerCase() ==
						(
							productFilters['productsorting']?.[0] ?? select.value
						).toLocaleLowerCase()
				);
				const reactSelect = React.createElement(Select, {
					options: options,
					defaultValue: selectvalue ?? options[0],
					classNamePrefix: 'select',
					onChange: (e: { value: string; content: string }) => {
						const value = e.value;
						productFilters['productsorting'] = value.split('|');
						refreshProduct(1);
					},
				});

				select.remove();

				ReactDOM.render(reactSelect, item);
			});
	};

	initialSelect();

	document
		.querySelectorAll('input[data-product-addition-filter]')
		.forEach((filter: HTMLInputElement) => {
			const filterName = filter
				.getAttribute('data-product-addition-filter')
				?.toLocaleLowerCase();
			if (!(filterName && filterName.trim() !== '')) {
				return;
			}
			if (!filterTypes.includes(filterName)) {
				filterTypes.push(filterName);
			}

			if (!(filterName in productFilters)) {
				productFilters[filterName] = [];
			}

			const filterHandleFunction = (e: Event) => {
				e.preventDefault();
				const target = e.currentTarget as HTMLInputElement;
				if (target.checked) {
					productFilters[filterName].push(target.value);
				} else {
					const index = productFilters[filterName].findIndex(
						(item) => item == target.value
					);
					if (index > -1) {
						productFilters[filterName].splice(index, 1);
					}
				}
			};

			filter.removeEventListener('change', filterHandleFunction);
			filter.addEventListener('change', filterHandleFunction);
		});

	// productOptionE?.addEventListener('change', (e) => {
	// 	e.preventDefault();
	// 	const productOption = (e.currentTarget as HTMLSelectElement).value;
	// 	productFilters['productsorting'] = productOption.split('|');
	// 	refreshProduct(1);
	// });

	document
		.querySelector('[data-button-event=applyFilter]')
		?.addEventListener('click', (e) => {
			e.preventDefault();
			Object.keys(productFilters).forEach((item) => {
				productFilters[item] = productFilters[item].filter(
					(value, index) => productFilters[item].indexOf(value) == index
				);
			});
			toggleFilterPanel('close');
			refreshProduct(1);
		});

	document
		.querySelector('[data-button-event=loadPrevious]')
		?.addEventListener('click', (e) => {
			e.preventDefault();

			const target = e.currentTarget as HTMLElement;
			target.classList.add('disabled');
			const currentSearch = getSearchParams(target.getAttribute('href') ?? '');
			const currentPreviousPage = Number.parseInt(
				currentSearch.get('page') ?? '1'
			);

			if (currentPreviousPage < 2) {
				target.parentElement.remove();
				refreshProduct(1, false, (success, nextPage) => {
					target.classList.remove('disabled');
				});
			} else {
				refreshProduct(currentPreviousPage, false, (success, nextPage) => {
					target.classList.remove('disabled');
				});
				const currentQuery = new URLSearchParams(window.location.search);
				currentQuery.set('page', (currentPreviousPage - 1).toString());
				target.setAttribute(
					'href',
					`${window.location.pathname}?${currentQuery.toString()}`
				);
			}
		});

	document
		.querySelector('[data-button-event=loadNext]')
		?.addEventListener('click', (e) => {
			e.preventDefault();
			const target = e.currentTarget as HTMLElement;
			target.classList.add('disabled');
			const newPage = getSearchParams(target.getAttribute('href'));
			const nextPage = Number.parseInt(newPage.get('page') ?? '1');

			refreshProduct(nextPage, true, (success, nextPage) => {
				target.classList.remove('disabled');
			});
		});

	const handleRemoveFilter = () => {
		const handleFunction = (e: Event) => {
			e.preventDefault();
			const target = e.currentTarget as HTMLElement;
			const codeName = target.getAttribute('data-remove-filter') ?? '';
			const parentType = target.getAttribute('data-remove-filter-type') ?? '';

			const itemIndex = productFilters[
				parentType.toLocaleLowerCase()
			].findIndex(
				(code) => code.toLocaleLowerCase() == codeName.toLocaleLowerCase()
			);
			if (itemIndex > -1) {
				productFilters[parentType.toLocaleLowerCase()] = productFilters[
					parentType.toLocaleLowerCase()
				].filter(
					(item) => item.toLocaleLowerCase() != codeName.toLocaleLowerCase()
				);

				document
					.querySelector(
						`input[data-product-addition-filter=${parentType} i][value=${codeName} i]`
					)
					.removeAttribute('checked');

				refreshProduct(1, true);
			}
		};
		document.querySelectorAll('button[data-remove-filter]')?.forEach((item) => {
			item.removeEventListener('click', handleFunction);
			item.addEventListener('click', handleFunction);
		});
	};

	handleRemoveFilter();

	const refreshProduct = (
		page: number,
		isAppend: boolean = true,
		callback?: (success: boolean, showNextPage: boolean) => void
	) => {
		if (isAppend) {
			if (page === 1) {
				productFilters['page'] = [];
			} else {
				productFilters['page'] = [page + ''];
			}
		}

		const searchParams = new URLSearchParams();
		let badges: string[] = [];
		Object.keys(productFilters).forEach((item) => {
			const data = productFilters[item];
			if (data.length > 0) {
				if (filterTypes.includes(item)) {
					const badgeText = data.map((type) => {
						const title = document
							.querySelector(
								`input[data-product-addition-filter=${item} i][value=${type} i]`
							)
							.getAttribute('title');
						return `<button data-remove-filter="${type}" data-remove-filter-type="${item}" class="form-filter-tag">
                                ${title}
                                <i class="icon-sm fa-regular fa-xmark"></i>
                            </button>`;
					});

					badges.push(badgeText.join(''));
				}
				searchParams.set(item, productFilters[item].join('|'));
			} else {
				searchParams.delete(item);
			}
		});

		document.querySelector('.product-list__filter_badge').innerHTML =
			badges.join('\n');

		handleRemoveFilter();

		let apiFetchURL = '';
		if (isAppend) {
			window.history.pushState({}, '', `?${searchParams.toString()}`);
			apiFetchURL = window.location.href;
		} else {
			searchParams.set('page', page + '');
			apiFetchURL = `${window.location.pathname}?${searchParams.toString()}`;
		}
		if (isAppend) handleNextPage(page);
		fetch(apiFetchURL, {
			headers: {
				'X-Requested-With': 'XMLHttpRequest',
			},
		})
			.then((res) => res.text())
			.then((htmlData) => {
				document.querySelector('[data-check-load-more]')?.remove();
				const wrapper = document.querySelector('.product-list__grid__wrapper');

				const parser = new DOMParser();
				const dom = parser.parseFromString(htmlData, 'text/html');
				const loadMoreE = dom.querySelector(
					'[data-check-load-more]'
				) as HTMLInputElement;

				const isLoadMore = loadMoreE?.value && loadMoreE.value.trim() !== '';
				loadMoreE.remove();

				const text = dom.querySelector('body')?.innerHTML;
				if (page == 1 && isAppend) {
					wrapper.innerHTML = text;
				} else {
					wrapper.insertAdjacentHTML(
						isAppend ? 'beforeend' : 'afterbegin',
						text ?? ''
					);
				}
				if (isAppend) {
					document.querySelector(
						'[data-button-event=loadNext]'
					).parentElement.style.display = isLoadMore ? '' : 'none';
				}
				callback?.(true, isLoadMore && isAppend);
			})
			.catch((e) => {
				callback?.(false, false);
			});
	};

	//Interface
	document
		.querySelector('[data-button-event=toggleFilter]')
		?.addEventListener('click', (e) => {
			e.preventDefault();
			toggleFilterPanel('toggle');
		});

	document
		.querySelector('[data-button-event=closeFilter]')
		?.addEventListener('click', (e) => {
			e.preventDefault();
			toggleFilterPanel('close');
		});

	document
		.querySelector('.product-list__filter__backdrop')
		.addEventListener('click', (e) => {
			e.preventDefault();
			toggleFilterPanel('close');
		});

	document
		.querySelectorAll('button.dynamic-card__favourite-icon')
		?.forEach((item) => {
			const eventName = item.getAttribute('data-button-event');

			if (eventName !== 'AddFavourite' && eventName !== 'RemoveFavourite') {
				return;
			}

			const nodeID = item
				.closest('[data-node-id]')
				?.getAttribute('data-node-id');

			const isExists = isExitsFavourite(nodeID ?? '');

			if (
				(eventName === 'AddFavourite' && isExists) ||
				(eventName === 'RemoveFavourite' && !isExists)
			) {
				item.classList.remove('d-none');
			} else {
				if (!item.classList.contains('d-none')) {
					item.classList.add('d-none');
				}
			}

			const handleEventFunction = (e: Event) => {
				e.preventDefault();
				handleFavouriteEvent(
					eventName === 'AddFavourite' ? 'Add' : 'Remove',
					nodeID
				);

				if (eventName === 'AddFavourite') {
					item.classList.add('d-none');
					item.parentElement
						.querySelector('button[data-button-event=RemoveFavourite]')
						.classList.remove('d-none');
				} else {
					item.classList.add('d-none');
					item.parentElement
						.querySelector('button[data-button-event=AddFavourite]')
						.classList.remove('d-none');
				}
			};

			item.removeEventListener('click', handleEventFunction);
			item.addEventListener('click', handleEventFunction);
		});

	const toggleFilterPanel = (type: 'toggle' | 'open' | 'close') => {
		const toggleFilter = document.querySelector(
			'[data-for-event=toggleFilter]'
		);
		if (type === 'toggle') {
			toggleFilterBackdrop(
				!toggleFilter.classList.contains('product-list__filter__panel--active')
			);
			toggleFilter.classList.toggle('product-list__filter__panel--active');
		} else if (type === 'open') {
			toggleFilterBackdrop(true);
			if (
				!toggleFilter.classList.contains('product-list__filter__panel--active')
			) {
				toggleFilter.classList.add('product-list__filter__panel--active');
			}
		} else {
			toggleFilter.classList.remove('product-list__filter__panel--active');
			toggleFilterBackdrop(false);
		}
	};

	const toggleFilterBackdrop = (panelVisibility: boolean) => {
		if (panelVisibility) {
			$('.product-list__filter__backdrop').fadeIn(300);
			$('.product-list__filter__backdrop').addClass(
				'product-list__filter__backdrop--active'
			);
		} else {
			$('.product-list__filter__backdrop').fadeOut(300);
			$('.product-list__filter__backdrop').removeClass(
				'product-list__filter__backdrop--active'
			);
		}
	};

	const handleFavouriteEvent = (state: 'Add' | 'Remove', nodeID: string) => {
		let favouriteList = JSON.parse(localStorage.getItem('favouriteList'));

		if (favouriteList === null) {
			favouriteList = [nodeID];
		} else {
			if (state === 'Add') {
				favouriteList.push(nodeID);
			} else {
				favouriteList = favouriteList.filter(
					(favNodeID) => favNodeID !== nodeID
				);
			}
		}

		localStorage.setItem('favouriteList', JSON.stringify(favouriteList));
	};

	const isExitsFavourite = (nodeID: string) => {
		const favouriteList: string[] = JSON.parse(
			localStorage.getItem('favouriteList')
		);
		if (favouriteList === null) return false;
		return favouriteList.includes(nodeID);
	};

	const handleNextPage = (page: number) => {
		if (page === 1) {
			document
				.querySelector('[data-button-event=loadPrevious]')
				?.parentElement.remove();
		}
		const search = new URLSearchParams(window.location.search);
		search.set('page', (page + 1).toString());

		document
			.querySelector('[data-button-event=loadNext]')
			?.setAttribute(
				'href',
				`${window.location.pathname}?${search.toString()}`
			);
	};
})();
